import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/consent';
const req = require.context('!raw-loader!../../../markdowns/consent', false, /\.(md|jsx)$/);

export default function Consent() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
